/* eslint import/prefer-default-export: 0 */
import axios from '../utils/api'

import CONFIG from '../config'
import { isCachedItem } from '../utils/caching'

import {
  FETCH_DEVICE_REQUEST, FETCH_DEVICE_RESPONSE,
  UPDATE_DEVICE_REQUEST, UPDATE_DEVICE_RESPONSE,
  REMOVE_DEVICE_REQUEST, REMOVE_DEVICE_RESPONSE,
  EXECUTE_DEVICE_COMMAND_REQUEST, EXECUTE_DEVICE_COMMAND_RESPONSE,
} from '../constants'

export function fetchDevice(deviceId) {
  // TODO: validation?
  return (dispatch, getState) => {
    if (isCachedItem(getState().devices, deviceId)) {
      return
    }
    dispatch({ type: FETCH_DEVICE_REQUEST, id: deviceId })

    axios.get(`${CONFIG.apiBase}/devices/${deviceId}`).then((response) => {
      dispatch({
        type: FETCH_DEVICE_RESPONSE,
        device: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function updateDevice(deviceId, update) {
  // TODO: validation?
  return (dispatch) => {
    dispatch({ type: UPDATE_DEVICE_REQUEST, deviceId })

    const d = {
      ...update,
      id: deviceId,
    }

    axios.put(`${CONFIG.apiBase}/devices/${deviceId}`, d).then((response) => {
      dispatch({
        type: UPDATE_DEVICE_RESPONSE,
        device: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function removeDevice(device) {
  // TODO: validation?
  return (dispatch) => {
    dispatch({ type: REMOVE_DEVICE_REQUEST, device })

    axios.delete(`${CONFIG.apiBase}/devices/${device.id}`, device).then(() => {
      dispatch({
        type: REMOVE_DEVICE_RESPONSE,
        id: device.id,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function executeCommand(deviceId, command, params) {
  return (dispatch) => {
    dispatch({ type: EXECUTE_DEVICE_COMMAND_REQUEST, deviceId })

    axios.post(`${CONFIG.apiBase}/devices/${deviceId}/commands`, { command, params }).then(() => {
      dispatch({ type: EXECUTE_DEVICE_COMMAND_RESPONSE, deviceId })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}
